import { Main } from "./components/pages/main/Main";

export default function Root(props) {
  return <Main {...props} />;
  // return <section><h1> hello world from client</h1></section>;
}
